import { withFormControl, InjectedInputProps } from './withFormControl';
import { Switch, Flex, FormHelperText } from '@chakra-ui/react';

type SwitchControlProps = InjectedInputProps & {
   onHelperText?: string;
   offHelperText?: string;
};

export const SwitchFormControl = withFormControl(
   ({ value, onHelperText, offHelperText, onBlur, ...props }: SwitchControlProps) => {
      return (
         <Flex align="center">
            <Switch {...props} isChecked={value} />
            <FormHelperText mt={0} ml={2}>
               {value ? onHelperText : offHelperText}
            </FormHelperText>
         </Flex>
      );
   }
);
